import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authSession } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const user = await authSession(sessionId);
        // Clear hash and navigate to admin dashboard
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user } });
      } catch (e) {
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-parchment" data-testid="auth-callback">
      <div className="text-center">
        <div className="label-eyebrow mb-3">Signing you in</div>
        <p className="font-serif text-2xl text-navy">One moment…</p>
      </div>
    </div>
  );
}
